import React from 'react'
import styled from 'styled-components'

import ButtonConfirm from 'components/ButtonConfirm'
import Section from 'components/Section'
import SubTitle from 'components/SubTitle'
import Select from 'components/Select'
import Tip from 'components/Tip'

import Label from 'components/Label'
import ArrowIcon from './images/ic-arrow.svg'

export default class SolarSistem extends React.Component {
  constructor(props) {
    super(props)
    this.isLoading = false

    this.handleButtonSelection = this.handleButtonSelection.bind(this)
    this.handleSelectSelection = this.handleSelectSelection.bind(this)

    this.state = {
      hasSolarSystem: false,
      open: false,
      solarSystemYear: this.props.year,
    }
  }

  shouldComponentUpdate() {
    const value = this.isLoading

    this.isLoading = true
    return value
  }

  componentWillMount() {
    const props = { ...this.props }
    let optItem =
      props.value !== undefined && props.value !== null
        ? { value: props.value }
        : this.getFirstSelectedItem('items')

    this.isLoading = false

    this.setState({
      hasSolarSystem: optItem.value,
      open: optItem.value,
      solarSystemYear: props.year,
    })

    if (this.props.onSelectionChange) {
      this.props.onSelectionChange({
        hasSolarSystem: optItem.value,
        solarSystemYear: props.year,
        first: true,
      })
    }
  }

  getFirstSelectedItem(prop) {
    this.props[prop] &&
      this.props[prop].forEach((item) => {
        if (item.status) return item
      })
    return this.props[prop] && this.props[prop][0]
  }

  handleButtonSelection(e) {
    if (this.props.onSelectionChange && !e.first) {
      this.props.onSelectionChange({
        hasSolarSystem: e.value,
        solarSystemYear: this.state.solarSystemYear,
      })
    }

    this.setState({
      hasSolarSystem: e.value,
      open: e.value,
    })
  }

  handleSelectSelection(e) {
    if (this.props.onSelectionChange && !e.first) {
      this.props.onSelectionChange({
        solarSystemYear: e.value,
        hasSolarSystem: this.state.hasSolarSystem,
      })
    }

    this.setState({
      solarSystemYear: e.value,
    })
  }

  render() {
    const { items, years, translations, iframed } = this.props
    const { CENTRAL_AIR_CONDITIONING } = translations || {}
    return (
      <Section
        title={`Sistema Solar Térmico`}
        subtitle={`A sua habitação possui Sistema Solar térmico?`}
        compact={iframed}>
        {CENTRAL_AIR_CONDITIONING && (
          <Tip data-slot='tip' text={CENTRAL_AIR_CONDITIONING} />
        )}
        <ButtonWrapper status={this.state.open}>
          <ButtonConfirm
            onButtonClick={this.handleButtonSelection}
            value={this.state && this.state.hasSolarSystem}
            items={items}
          />
        </ButtonWrapper>
        <SelectorWrapper status={this.state.open}>
          <SubTitle
            text={`Indique o ano de instalação do Sistema Solar Térmico`}
          />
          <WrapperSelect>
            <LocationLabel fontSize='12px'>ANO DE INSTALAÇÃO</LocationLabel>
            <StyledSelect
              margin
              placeholder={'Selecione'}
              items={years}
              onChange={this.handleSelectSelection}
              selected={this.state.solarSystemYear}
              arrowIcon={ArrowIcon}
            />
          </WrapperSelect>
        </SelectorWrapper>
      </Section>
    )
  }
}

const ButtonWrapper = styled.div`
  display: block;
  text-align: center;
  margin-bottom: 81px;
  ${({ status }) =>
    !status &&
    `
    margin-bottom: 0px;
  `}
`

const SelectorWrapper = styled.div`
  display: block;
  border-top: 1px solid #dedede;
  overflow: visible;
  padding-top: 80px;

  ${({ status }) =>
    !status &&
    `
    padding-top: 0px;
    border-top: none;
    overflow: hidden;
    height: 0px;
  `}
`

const WrapperSelect = styled.div`
  display: inline-block;
  width: auto;
  margin-top: 32px;
`

const StyledSelect = styled(Select)`
  width: 166px;
  float: left;
  max-width: 166px;

  > div {
    border: 1px solid #bababa;
    color: #3e3e3e;
  }
  ${({ margin }) => margin && `margin-right: 30px;`}
`

const LocationLabel = styled(Label)`
  text-align: left;
  padding-bottom: 5px;
`



// WEBPACK FOOTER //
// ./src/containers/SolarSistem/index.js